import { render, staticRenderFns } from "./tokenInvalid.vue?vue&type=template&id=fddb7000"
import script from "./tokenInvalid.vue?vue&type=script&lang=js"
export * from "./tokenInvalid.vue?vue&type=script&lang=js"
import style0 from "./tokenInvalid.vue?vue&type=style&index=0&id=fddb7000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports